import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Breadcrumb } from './Breadcrumb';
import { Heading } from './Heading';
import { Description } from './Description';
import { ProductGrid } from './ProductGrid';
/**
 * Daedo PSS Systems category page (/shop/daedo-pss-system/).
 *
 * Self-contained: every section lives in `./` and is owned by this page only.
 */
export function DaedoPSSSystemPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-203">
      <Header data-id="element-204" />
      <main className="flex-grow pt-32 pb-20" data-id="element-205">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-206">
          <Breadcrumb data-id="element-207" />
          <Heading data-id="element-208" />
          <Description data-id="element-209" />
          <ProductGrid data-id="element-210" />
        </div>
      </main>
      <Footer data-id="element-211" />
    </div>;
}